import { useParams, useSearchParams } from 'react-router-dom';
import { QRPrintPage } from '../components/qr/QRPrintPage';

export function QRBusinessPrint() {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const name = searchParams.get('name') || 'Obiekt Spotto';
  const url = `https://spotto.pl/book/${id}`;

  return <QRPrintPage url={url} entityName={name} entityType="business" />;
}
